import React from 'react'
import { useTranslation } from 'react-i18next'
import {Tooltip} from 'antd'
import {Icon} from '@/components'
import styles from './styles.scss'
import {DOWNLOAD_BUTTON} from '@/constants/playwright-ids'

export const DownloadReceipt = () => {
    const { t } = useTranslation()
    return (
        <Tooltip placement="top" title={t('DownloadReceipt.downloadReceipt')} data-test-id={DOWNLOAD_BUTTON}>
            <Icon className={styles.pdfIcon} type={'pdf'}/>
        </Tooltip>
    )
}
